import FormSectionTitle from '../../../../../../elements/FormSectionTitle'
import useFetchSelectUrl from '../../../../../../elements/Hooks/useFetchSelectUrl'
import UOM from '../../../../../../elements/Select/UOM'
import { defaultFormItemLayout, rules } from '../../../../../../modules/FormItems'
import React, { useEffect, useState } from 'react'
import { get, isEmpty } from 'lodash'
import { dateVal } from '../../../../../../modules/Utils'
import RecurringDay from '../../../../../../elements/Select/Lines/RecurringDay'
import RecurringFrequency from '../../../../../../elements/Select/Lines/RecurringFrequency'
import withSort from '../../../../../../elements/HOC/withSort'
import { compose } from 'recompose'
import CustomSelect from '../../../../../../elements/Select/CustomSelect'
import BooleanSelect from '../../../../../../elements/Select/Boolean'
import TaxType from '../../../../../../elements/Select/Lines/TaxType'
import withSelectFetch from '../../../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../../../elements/HOC/withSpinning'
import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, TimePicker } from 'antd'
import InfoTooltip from '../../../../../../elements/InfoTooltip'

const { TextArea } = Input

const FuelTypeSelect = compose(
  withSelectFetch({ dropdown: 'fuel', name: 'type', cache: true }),
  withSpinning,
  withSort,
)(CustomSelect)

function OrderLineForm (props) {
  const { orderLine, orderLineModalType, contract, keyAtr, productsUrl } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form

  const [product, setProduct] = useState({})
  const [productLine, setProductLine] = useState({})
  const productID = getFieldValue('product._id') || get(orderLine, 'product._id')
  const productsLineUrl = `products/lines?product=${productID}&select=*`

  const [ProductsSelect] = useFetchSelectUrl(
    {
      name: 'products',
      url: productsUrl,
      forceFetch: true,
    },
    [productsUrl],
    isEmpty(productsUrl),
  )
  const [ProductsLinesSelect] = useFetchSelectUrl(
    {
      name: 'products_lines',
      url: productsLineUrl,
      forceFetch: true,
    },
    [productsLineUrl],
    isEmpty(productID),
  )

  useEffect(() => {
    if (!isEmpty(product)) {
      console.log(product)
      setFieldsValue()
    }
  }, [product])

  useEffect(() => {
    if (!isEmpty(productLine)) {
      let description, uom
      if (productLine._id === get(orderLine, 'productLine._id')) {
        description = get(orderLine, 'description')
        uom = get(orderLine, 'uom')
      } else {
        description = get(productLine, 'description') || get(orderLine, 'description')
        uom = get(productLine, 'uom') || get(orderLine, 'uom')
      }
      setFieldsValue({ description, uom })
    }
  }, [productLine])

  console.log(contract)

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'No'}>
            {getFieldDecorator('no', {
              initialValue: get(orderLine, 'no'),
              rules: rules.input,
            })(<Input placeholder={'No'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Name'}>
            {getFieldDecorator('name', {
              initialValue: get(orderLine, 'name'),
              rules: rules.input,
            })(<Input placeholder={'No'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Product'}>
            {getFieldDecorator('product._id', {
              initialValue: get(orderLine, 'product._id'),
              rules: rules.select,
            })(
              <ProductsSelect
                placeholder={'Product'}
                keyAtr={'_id'}
                valueAtr={'name'}
                setSelected={setProduct}
                // onChange={onChangeProductLine}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Product Line'}>
            {getFieldDecorator('productLine._id', {
              initialValue: get(orderLine, 'productLine._id'),
              rules: rules.select,
            })(
              <ProductsLinesSelect
                placeholder={'Product'}
                keyAtr={'_id'}
                valueAtr={'name'}
                disabled={!productID}
                setSelected={setProductLine}
                // onChange={onChangeProductLine}
              />,
            )}
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item {...defaultFormItemLayout} label={'Description'}>
            {getFieldDecorator('description', {
              initialValue: get(orderLine, 'description'),
              rules: [{ required: true, message: 'Description can\'t be Empty!' }],
            })(<TextArea rows={3} placeholder={'Description'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Quantity'}>
            {getFieldDecorator('unit', {
              initialValue: get(orderLine, 'unit'),
              rules: [{ required: true, message: 'Quantity can\'t be Empty!' }],
            })(<InputNumber style={{ width: '100%' }} placeholder={'Quantity'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="UOM">
            {getFieldDecorator('uom.code', {
              initialValue: get(orderLine, 'uom.code'),
              rules: rules.select,
            })(<UOM/>)}
          </Form.Item>
          {/*<Form.Item {...defaultFormItemLayout} label={'UOM'}>*/}
          {/*  {getFieldDecorator('uom.key', {*/}
          {/*    initialValue: get(orderLine, 'uom.key'),*/}
          {/*    rules: [{ required: true, message: "UOM can't be Empty!" }],*/}
          {/*  })(*/}
          {/*    <UOMSelect*/}
          {/*      keyAtr={'uom.key'}*/}
          {/*      valueAtr={'uom.name'}*/}
          {/*      display={get(orderLine, 'uom.name') || get(orderLine, 'uom.key')}*/}
          {/*      dataIndex={keyAtr}*/}
          {/*      onChange={v => this.handleChange(v, 'uom.key')}*/}
          {/*    />,*/}
          {/*  )}*/}
          {/*</Form.Item>*/}
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Rate'}>
            {getFieldDecorator('rate', {
              initialValue: get(orderLine, 'rate'),
              rules: [{ required: true, message: 'Please Select a Rate!' }],
            })(<InputNumber style={{ width: '100%' }} placeholder={'Rate'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Tax Percentage'}>
            {getFieldDecorator('tax.percentage', {
              initialValue: get(contract, 'tax.percentage') || get(orderLine, 'tax.percentage'),
              rules: [{ required: true, message: 'Please Select a Tax Percentage!' }],
            })(<InputNumber style={{ width: '100%' }} placeholder={'Tax Rate'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Tax Type'}>
            {getFieldDecorator('tax.type', {
              initialValue: get(contract, 'tax.type') || get(orderLine, 'tax.type'),
              rules: [{ required: true, message: 'Please Select a Tax Type!' }],
            })(
              <TaxType
                style={{ width: '100%' }}
                placeholder={'Tax Rate'}
                // onChange={v => handleChange(v, 'tax.type')}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={
              <InfoTooltip
                value={'Billing Start'}
                title={'The date from which services will be billed. '}
              />
            }>
            {getFieldDecorator('billing.start', {
              initialValue:
                orderLineModalType === 'new'
                  ? dateVal(contract, 'billing.period.start')
                  : dateVal(orderLine, 'billing.start'),
              rules: [{ required: true, message: 'Please Select a Billing Start!' }],
            })(<DatePicker style={{ width: '100%' }} placeholder={'Billing Start'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={
              <InfoTooltip
                value={'Billing End'}
                title={'The date to which services will be billed.'}
              />
            }>
            {getFieldDecorator('billing.end', {
              initialValue: dateVal(orderLine, 'billing.end'),
            })(<DatePicker style={{ width: '100%' }} placeholder={'Billing End'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Delivery'}>
            {getFieldDecorator('recurring.delivery', {
              initialValue: get(orderLine, 'recurring.delivery'),
              rules: [{ required: true, message: 'Please Select a Delivery Value!' }],
            })(<BooleanSelect/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Recurring'}>
            {getFieldDecorator('recurring.value', {
              initialValue: get(orderLine, 'recurring.value'),
              rules: [{ required: true, message: 'Please Select a Recurring Value!' }],
            })(
              <BooleanSelect
                // onChange={v => handleChange(v, 'recurring.value')}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
      {getFieldValue('recurring.value') && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Frequency'}>
              {getFieldDecorator('recurring.frequency', {
                initialValue: get(orderLine, 'recurring.frequency'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Recurring Frequency!',
                  },
                ],
              })(<RecurringFrequency/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...defaultFormItemLayout}
              label={
                <InfoTooltip value={'Billing Day'} title={'The last day of the billing period.'}/>
              }>
              {getFieldDecorator('recurring.day', {
                initialValue: get(orderLine, 'recurring.day'),
                rules: [{ required: true, message: 'Please Select a Billing Day!' }],
              })(<RecurringDay/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Recurring Quantity'}>
              {getFieldDecorator('recurring.unit', {
                initialValue: get(orderLine, 'recurring.unit'),
                rules: [
                  {
                    required: true,
                    message: 'Recurring Quantity can\'t be Empty!',
                  },
                ],
              })(<InputNumber style={{ width: '100%' }} placeholder={'Recurring Quantity'}/>)}
            </Form.Item>
          </Col>
        </Row>
      )}
      {get(product, 'category.code') === 'vehicles' && (
        <Row>
          <h3>Vehicle</h3>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                {getFieldDecorator('ancillary.vehicle.plate', {
                  initialValue: get(orderLine, 'ancillary.vehicle.plate'),
                })(<Input placeholder={'Plate No'}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Is Replacement'}>
                {getFieldDecorator('ancillary.vehicle.replacement', {
                  initialValue: get(orderLine, 'ancillary.vehicle.replacement'),
                  valuePropName: 'checked',
                })(<Checkbox placeholder={'Is Replacement'}/>)}
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ marginLeft: 10 }}>
            <h4>Pick up / Drop off</h4>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Pick Up'}>
                {getFieldDecorator('ancillary.vehicle.pickup.date', {
                  initialValue: dateVal(orderLine, 'ancillary.vehicle.pickup.date'),
                })(<DatePicker placeholder="Pick up Date" format="ddd YYYY-MM-DD"/>)}
                {getFieldDecorator('ancillary.vehicle.pickup.time', {
                  initialValue: dateVal(orderLine, 'ancillary.vehicle.pickup.time'),
                })(
                  <TimePicker
                    format="HH:mm"
                    style={{ marginLeft: 10 }}
                    placeholder="Pick up Time"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Drop off'}>
                {getFieldDecorator('ancillary.vehicle.dropOff.date', {
                  initialValue: dateVal(orderLine, 'ancillary.vehicle.dropOff.date'),
                })(<DatePicker placeholder="Drop off Date" format="ddd YYYY-MM-DD"/>)}
                {getFieldDecorator('ancillary.vehicle.dropOff.time', {
                  initialValue: dateVal(orderLine, 'ancillary.vehicle.dropOff.time'),
                })(
                  <TimePicker
                    format="HH:mm"
                    style={{ marginLeft: 10 }}
                    placeholder="Drop off Time"
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <FormSectionTitle title={'Salik'}/>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Tag No'}>
                {getFieldDecorator('ancillary.salik.tag', {
                  initialValue: get(orderLine, 'ancillary.salik.tag'),
                })(<Input placeholder={'Tag No'}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Rate'}>
                {getFieldDecorator('ancillary.salik.base.rate', {
                  initialValue: get(orderLine, 'ancillary.salik.base.rate'),
                })(<InputNumber style={{ width: '100%' }} placeholder={'Rate'}/>)}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Tax Rate'}>
                {getFieldDecorator('ancillary.salik.base.tax.rate', {
                  initialValue: get(orderLine, 'ancillary.salik.base.tax.rate'),
                })(<InputNumber style={{ width: '100%' }} placeholder={'Tax Rate'}/>)}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Tax Type'}>
                {getFieldDecorator('ancillary.salik.base.tax.type', {
                  initialValue: get(orderLine, 'ancillary.salik.base.tax.type'),
                })(<TaxType placeholder={'Tax Type'}/>)}
              </Form.Item>
            </Col>
          </Row>
        </Row>
      )}
      {get(product, 'category.code') === 'commuter-services' && (
        <Row>
          <FormSectionTitle title={'Fuel'}/>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Type'}>
                {getFieldDecorator('ancillary.fuel.type', {
                  initialValue: get(orderLine, 'ancillary.fuel.type'),
                })(<FuelTypeSelect placeholder={'Type'}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Rate'}>
                {getFieldDecorator('ancillary.fuel.rate', {
                  initialValue: get(orderLine, 'ancillary.fuel.rate'),
                })(<InputNumber style={{ width: '100%' }} placeholder={'Rate'}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Tax Type'}>
                {getFieldDecorator('ancillary.fuel.tax.type', {
                  initialValue: get(orderLine, 'ancillary.fuel.tax.type'),
                })(<TaxType placeholder={'Tax Type'}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Tax Rate'}>
                {getFieldDecorator('ancillary.fuel.tax.rate', {
                  initialValue: get(orderLine, 'ancillary.fuel.tax.rate'),
                })(<InputNumber style={{ width: '100%' }} placeholder={'Tax Rate'}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Contract Amount'}>
                {getFieldDecorator('ancillary.fuel.contractAmount', {
                  initialValue: get(orderLine, 'ancillary.fuel.contractAmount'),
                })(<InputNumber style={{ width: '100%' }} placeholder={'Contract Amount'}/>)}
              </Form.Item>
            </Col>
          </Row>
        </Row>
      )}
    </Form>
  )
}

OrderLineForm.propTypes = {}
OrderLineForm.defaultProps = {
  orderLine: {},
  type: 'new',
}

export default Form.create()(OrderLineForm)
